
<app-form-input
    [parentForm]="parentForm"
    [value]="voie?.num"
    [label]="step2.getnum"
    [disabled]="disabled"
    [type]="'text'" [rule]="rule + '|minSize_1|maxSize_50'"
    [errorMessage]="errorMessage"
    [name]="getUid()+'_SepAtt_num'">
</app-form-input>
<app-form-input-error *ngIf="getUid().includes('lieuExecution_')" [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error *ngIf="getUid().includes('lieuExecutionLivraison_')" [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error *ngIf="getUid().includes('lieuLivraison_')" [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<app-form-input
    [parentForm]="parentForm"
    [value]="voie?.typevoie"
    [label]="step2.gettypevoie"
    [disabled]="disabled"
    [type]="'text'" [rule]="rule + '|minSize_1|maxSize_255'"
    [errorMessage]="errorMessage"
    [name]="getUid()+'_SepAtt_typevoie'">
</app-form-input>
<app-form-input-error *ngIf="getUid().includes('lieuExecution_')" [activeForm]="parentForm" [name]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error *ngIf="getUid().includes('lieuExecutionLivraison_')" [activeForm]="parentForm" [name]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error *ngIf="getUid().includes('lieuLivraison_')" [activeForm]="parentForm" [name]="getStepId() + rg2"></app-form-input-error>

<app-form-input
    [parentForm]="parentForm"
    [value]="voie?.nomvoie"
    [label]="step2.getnomvoie"
    [disabled]="disabled"
    [type]="'text'" [rule]="rule + '|minSize_5|maxSize_1000'"
    [errorMessage]="errorMessage"
    [name]="getUid()+'_SepAtt_nomvoie'">
</app-form-input>
<app-form-input-error *ngIf="getUid().includes('lieuExecution_')" [activeForm]="parentForm" [name]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error *ngIf="getUid().includes('lieuExecutionLivraison_')" [activeForm]="parentForm" [name]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error *ngIf="getUid().includes('lieuLivraison_')" [activeForm]="parentForm" [name]="getStepId() + rg2"></app-form-input-error>
